import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CartProvider } from './figma-frontend/src/app/CartContext';
import { AppRoutes } from './figma-frontend/src/app/routes';
import { SeoHead } from './figma-frontend/src/app/components/SeoHead';

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <SeoHead />
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
